import React, { useEffect, useState } from 'react';

import { makeStyles } from '@material-ui/core';
import moment from 'moment/moment';

import CaseStatusCell from './CaseStatusCell';
import { mapOrderField } from '../../models/Case';
import Table from '../common/Table';

const useStyles = makeStyles((theme) => {
  return {
    workspaceName: {
      color: theme.palette.primary.main,
    },
  };
});

export default ({ cases, total, onCriteriaChange, onCaseClick, page, workspace }) => {
  const columns = [
    {
      label: 'Status',
      name: 'status',
      options: {
        customBodyRender: (value, meta) => {
          const color = meta.rowData[5];
          return <CaseStatusCell status={value.label} color={color} />;
        },
      },
      sort: true,
    },
    {
      label: workspace.productType !== 'law-firm' ? 'Patient' : 'Claimant',
      name: 'patientName',
    },
    {
      label: 'Study',
      name: 'description',
      options: {
        customBodyRender: (value) => {
          return <span style={{ color: '#999999' }}>{value || ''}</span>;
        },
      },
    },
    {
      label: 'Workspace',
      name: 'workspaceName',
      options: {
        customBodyRender: (value) => {
          return <span className={classes.workspaceName}>{value}</span>;
        },
      },
    },
    {
      label: 'Last Update',
      name: 'updatedAt',
      options: {
        customBodyRender: (value) => {
          const formattedDate = value ? moment(value).format('MM/DD/YYYY - HH:mm') : 'N/A';
          return <span style={{ color: '#999999' }}>{formattedDate}</span>;
        },
      },
    },
    {
      label: '',
      name: 'statusColor',
      options: { display: false },
    },
    {
      label: '',
      name: 'isDelayed',
      options: { display: false },
    },
  ];

  const defaultOptions = {
    count: total,
    onRowSelectionChange: (currentRowsSelected) => {
      const { id } = cases[currentRowsSelected[0].index];
      onCaseClick(id);
    },
    onTableChange: (action, tableState) => {
      const criteria = {};
      switch (action) {
        case 'sort':
          criteria.orderType = tableState.sortOrder.direction.toUpperCase();
          criteria.orderField = mapOrderField(tableState.sortOrder.name);
          break;
        case 'changePage':
          criteria.page = tableState.page;
          break;
        case 'changeRowsPerPage':
          criteria.limit = tableState.rowsPerPage;
          setTableOptions({
            ...tableOptions,
            rowsPerPage: tableState.rowsPerPage,
          });
          break;
        default:
          return;
      }
      onCriteriaChange(criteria);
    },
    serverSide: true,
  };

  useEffect(() => {
    setTableOptions({
      ...tableOptions,
      count: total,
      onRowSelectionChange: (currentRowsSelected) => {
        const caseStudy = cases[currentRowsSelected[0].index];
        onCaseClick(caseStudy);
      },
      page,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [total, cases, page]);

  const [tableOptions, setTableOptions] = useState(defaultOptions);

  const classes = useStyles();

  return <Table className="small-padding-table" columns={columns} data={cases || []} options={tableOptions} />;
};
